<script>
    import Thumbnail from '../../common/Media/Thumbnail.svelte';
    import IconButton from '../../common/Button/IconButton.svelte';
    import {sgettext} from '../../../i18n.js';

    export let id = 0;
    export let url = '';
    export let media = '';
    export let type = '';
    export let handleDelete = () => {};
    export let handleClick = () => {};


    function onFullSizeClick(){
        showImage = true;
    }

    function onThumbnailClick(event){
        handleClick(id);
    }

    let showImage = false;
</script>

<style>
    .element-media {
        position: relative;
        display:flex;
        flex: 1;
    }

    .element-media :global(.thumbnail) {
        flex: 1;
    }

    .action-bar {
        display: flex;
        flex-direction: column;
        padding: 0 2px;
    }

    .action-bar :global(.fas) {
        opacity: 0.5;
        cursor: pointer;
    }

    .action-bar :global(.fas:hover) {
        opacity: 1;
        color: #dd5900;
    }
</style>

<div class="element-media">    
    <Thumbnail 
        {url}
        {media}
        {type}
        bind:showImage={showImage}
        handleClick={onThumbnailClick}
    />
    <div class="action-bar">
        <IconButton 
            title={sgettext("$$DELETE_1$$")}
            on:click={() => handleDelete(id)}
            classes="fas fa5-trash-alt" />
        <IconButton 
            title={sgettext("$$VIEW_FULL_SIZE$$")}
            on:click={onFullSizeClick} 
            classes="fas fa5-expand-arrows-alt" />

    </div>
</div>